<template>
	
	<el-dialog title="信息" :visible.sync="infoShow" :append-to-body="true">
	
	
		<div class = "info_table">
			
			<div  v-for = "(item,index) in Object.keys(obj)" :key = "index">
				
				<span v-if = "obj[item]" style="margin-right: 3vw;">{{getCN(item)}}</span>
				<span v-if = "obj[item]">{{obj[item]}}</span>
				
			</div>
			
			
		</div>
	
	
	
		
	</el-dialog>
	
</template>

<script>
	import {cn} from '../../utils/CN.js'
	export default{
		
		props:{
			
			obj:Object
			
		},
		
		
		data(){
			
			return {
				cn:cn,
				infoShow:false
			}
			
		},
		methods:{
			getCN(key){
				
				for(let o of cn){
					
					if(this.toHump(o['COLUMN_NAME'])==key) return o['column_comment']
					
				}
				
				
			},
			
			// 下划线转换驼峰
			toHump(name) {
			    return name.replace(/\_(\w)/g, function(all, letter){
			        return letter.toUpperCase();
			    });
			}
			
			
		}
		
	}
	
	
</script>

<style>
	.info_table{
		
		
		
		
	}
</style>
